import Link from '../../ui/Link';
import {emptyStringIfNil} from '../utils';

const COLOR_SCHEME_REGEX = /^(brand|grey|black)(\sinv)?$/;
const INVERT_COLOR_SCHEME_STYLE_PROPERTY_PART = ' inv';

const getColorSchemeParts = (colorSchemeStyleProperty) => {
    const [, colorScheme, invertColorScheme] = COLOR_SCHEME_REGEX.exec(colorSchemeStyleProperty.trim());
    return {
        colorScheme,
        invertColorScheme: emptyStringIfNil(invertColorScheme)
    };
};

const getColorSchemeStyleProperty = (colorScheme, invertColors) => {
    return colorScheme.concat(invertColors ? INVERT_COLOR_SCHEME_STYLE_PROPERTY_PART : '');
};

const convertToUserFormat = (actionItem) => {
    const link = actionItem.link;
    return {
        itemType: actionItem.itemType,
        label: actionItem.text,
        link: emptyStringIfNil(link && (link.link || new Link(link).getValue()))
    };
};

export default {
    getColorSchemeParts,
    getColorSchemeStyleProperty,
    convertToUserFormat
};
